import { ColDef } from 'ag-grid-community';
import { formatColumnDate, formatNumber, formatPrice, getPureNumber } from '../../lib/utils';

export const Dividends = [
  {
    cellClass: 'ticker-cell',
    cellStyle: { fontWeight: 'bold' },
    field: 'ex_dividend_date',
    flex: 1,
    headerName: 'Ex-Date',
    // initialSort: 'desc' as ColDef['initialSort'], // this should probably stick to asc
    maxWidth: 90,
    minWidth: 80,
    valueFormatter: ({ data }: any) => formatColumnDate(data.ex_dividend_date),
    valueGetter: ({ data }: any): any => {
      if (!data.ex_dividend_date) return null;
      return data.ex_dividend_date;
    },
    width: 60,
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    cellStyle: { fontWeight: 'bold' },
    field: 'ticker',
    flex: 1,
    width: 60,
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    cellRendererParams: {
      tickerLogoVisible: true,
    },
    cellStyle: { fontWeight: 'bold' },
    field: 'name',
    width: 200,
  },
  {
    cellClass: 'ticker-cell',
    field: 'dividend',
    flex: 1,
    headerName: 'Dividend',
    valueFormatter: ({ value }: any) => formatPrice(value),
    valueGetter: ({ data }: any) => getPureNumber(data.dividend),
    width: 50,
  },
  {
    cellClass: 'ticker-cell',
    field: 'dividend_yield',
    flex: 1,
    headerName: 'Yield',
    valueFormatter: ({ value }: any) => {
      if (!value) return '-';
      return `${value}%`;
    },
    valueGetter: ({ data }: any) => {
      if (!data.dividend_yield) return 0;
      return Number(formatNumber(data.dividend_yield * 100));
    },
    width: 50,
  },
  {
    cellClass: 'ticker-cell',
    cellStyle: { fontWeight: 'bold' },
    field: 'date',
    flex: 1,
    headerName: 'Announced',
    valueFormatter: ({ data }: any) => formatColumnDate(data.date),
    valueGetter: ({ data }: any) => {
      if (!data.date) return null;
      return data.date;
    },
    width: 70,
  },
  {
    cellClass: 'ticker-cell',
    cellStyle: { fontWeight: 'bold' },
    field: 'record_date',
    flex: 1,
    headerName: 'Record',
    valueFormatter: ({ data }: any) => formatColumnDate(data.record_date),
    valueGetter: ({ data }: any) => {
      if (!data.record_date) return null;
      return data.record_date;
    },
    width: 70,
  },
  {
    cellClass: 'ticker-cell',
    cellStyle: { fontWeight: 'bold' },
    field: 'payable_date',
    flex: 1,
    headerName: 'Payable',
    valueFormatter: ({ data }: any) => formatColumnDate(data.payable_date),
    valueGetter: ({ data }: any) => {
      if (!data.payable_date) return null;
      return data.payable_date;
    },
    width: 70,
  },
] as ColDef[];
